'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/bail/index.js
// module id = 1522
// module chunks = 0